/**
 * Main
 */
import styles from './Main.css'

import Header from './Header'
import Toast from './Toast'
import SidebarRoute from '../Routes/Sidebar'
import ContentWithSubSideBar from './HorizontalLayout/ContentWithSubSideBar'

const Main = (props) => {
  const { page, supplier, routes, children, render, actions } = props
  const { user, toast = {} } = page || {}

  const renderChildren = () => {
    if (render) {
      return render()
    }

    if (typeof children === 'function') {
      return children()
    }

    return children
  }

  return (
    <div className={'pure-g'}>
      {toast && toast.active && (
        <div className='pure-u-1'>
          <Toast
            toast={toast}
            switchToast={actions.switchToast}
          />
        </div>
      )}
      <div className='pure-u-1'>
        <Header
          user={user}
          page={page}
          {...props}
        />
      </div>
      <main className={`pure-u-1 ${styles.main}`}>
        <ContentWithSubSideBar
          subSideBar={(
            <SidebarRoute
              supplier={supplier}
              page={page}
              routes={routes}
              actions={actions}
            />
          )}
        >
          <div className={styles.pageContainer}>
            {/* 主要子組件 */}
            {renderChildren()}
          </div>
        </ContentWithSubSideBar>
      </main>
    </div>
  )
}

export default Main
